export enum FrequencyCap {
  INDEX = '/frequency-cap',
}
